import React from 'react'
import { Tooltip } from '@material-ui/core'
import { getEntry, exampleFor, ASPIRE_INFLATED_WARNING } from './hoursGlossary'

function TooltipBody({ entry, example }) {
  return (
    <div style={{ maxWidth: 300 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 4 }}>
        <span style={{ fontWeight: 500 }}>{entry.label}</span>
        {/* Translucent-white pill assumes MUI v4's default dark tooltip background. */}
        <span style={{ fontSize: 11, padding: '1px 6px', borderRadius: 4, background: 'rgba(255,255,255,0.18)' }}>{entry.unit}</span>
      </div>
      <div style={{ fontSize: 12, lineHeight: 1.5, opacity: 0.92 }}>{entry.definition}</div>
      {example && (
        <div style={{ marginTop: 6, fontFamily: 'monospace', fontSize: 12 }}>
          {example.display}
          {example.note && <div style={{ opacity: 0.7 }}>{example.note}</div>}
          {example.crewSource === 'planned-default' && <div style={{ opacity: 0.7 }}>assumed crew ({example.crew}) — sharpens with data or Refine Route</div>}
          {/* Reserved for when per-visit crew data lands (later optional server task); today only 'planned-default'/'planned-override' are emitted. */}
          {example.crewSource === 'visit' && <div style={{ opacity: 0.7 }}>crew from visit record</div>}
          {example.crewSource === 'planned-override' && <div style={{ opacity: 0.7 }}>crew set in Refine Route</div>}
        </div>
      )}
      {entry.caveat === 'aspire-inflated' && (
        <div style={{ marginTop: 6, fontSize: 12, lineHeight: 1.5 }}>{ASPIRE_INFLATED_WARNING}</div>
      )}
    </div>
  )
}

export default function HoursValue({ termKey, property, children }) {
  const entry = getEntry(termKey)
  if (!entry) return <>{children}</>
  const example = exampleFor(termKey, property)
  return (
    <Tooltip arrow interactive title={<TooltipBody entry={entry} example={example} />}>
      <span tabIndex={0} style={{ cursor: 'help', borderBottom: '1px dotted currentColor' }}>{children}</span>
    </Tooltip>
  )
}
